module.exports = __webpack_public_path__ + "static/BlueBackgroundB-a240ab10bbe19a45ba34c6392d842343.png";